module.exports = __webpack_public_path__ + "img/tm_img2.cff0cc82.png";